module.exports = __webpack_public_path__ + "static/media/Menu White.c01a5ebf.svg";